/**
 * `ShopFeatures.marketDrivenShipping` only exists in recent Admin API versions (market-driven
 * shipping went into feature preview in July 2026), so this query is pinned to its own version
 * instead of being added to `GET_SHOP_DATA_QUERY`, which runs on the app's default version.
 */
export const SHOP_FEATURES_API_VERSION = '2026-10';

export const GET_SHOP_FEATURES_QUERY = /* GraphQL */ `
    query GetShopFeatures {
        shop {
            id
            features {
                marketDrivenShipping
            }
        }
    }
`;

export interface GetShopFeaturesResponse {
    shop: {
        id: string;
        features: {
            /** Whether market-driven shipping is enabled for the shop. */
            marketDrivenShipping: boolean;
        };
    };
}
